import {css} from 'lit'; export default css`:host{align-items:center;display:flex;justify-content:space-between}`;
    